/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=fb4ae5a8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/高保障-案例中心-前台页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__